var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_156",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.838745 0.904776H23.014V23.0801H0.838745V0.904776Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5621 8.52216L20.1597 9.78589L22.5811 11.9919L20.1597 14.198L21.1536 17.3192L17.9536 18.0191L17.2538 21.2191L14.1326 20.2252L11.9265 22.6465L9.72042 20.2252L6.59924 21.2191L5.89938 18.0191L2.69938 17.3192L3.69333 14.198L1.27197 11.9919L3.69333 9.78589L2.69938 6.66467L5.89938 5.96485L6.59924 2.76485L9.72042 3.75876L11.9265 1.3374L14.1326 3.75876L17.2538 2.76485L17.9536 5.96485L19.2495 6.24828",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80727 7.66109H6.50793V11.126",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50793 9.36133H7.70406",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3071 7.66109H13.0078V11.126H14.3071",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2113 9.39355H13.0078",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3449 7.66109H16.0455V11.126H17.3449",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2491 9.39355H16.0455",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82007 9.47227L11.2755 11.126",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53235 7.66109V11.126",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_202_156",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.838745 0.904776H23.014V23.0801H0.838745V0.904776Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_202_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2758 8.56233C11.2758 9.05967 10.8397 9.46286 10.3244 9.46286C10.0688 9.46286 9.53998 9.4668 9.53998 9.4668C9.53998 9.4668 9.53586 8.81302 9.53586 8.56233C9.53586 8.35647 9.53357 7.66185 9.53357 7.66185H10.3244C10.8397 7.66185 11.2758 8.06503 11.2758 8.56233Z",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66772 12.8594H7.22693",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44397 12.97V16.3242",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02966 14.6705L10.4851 16.3242",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74194 12.8593V16.3242",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4853 13.7596C10.4853 14.2569 10.0493 14.6601 9.53386 14.6601C9.27828 14.6601 8.74945 14.6641 8.74945 14.6641C8.74945 14.6641 8.74538 14.0103 8.74534 13.7596C8.74534 13.5537 8.74304 12.8591 8.74304 12.8591H9.53386C10.0493 12.8591 10.4853 13.2623 10.4853 13.7596Z",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1467 16.3242L14.4478 12.9081C14.4744 12.8431 14.5664 12.843 14.5931 12.908L15.8823 16.3242",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5526 15.4736H15.4832",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8361 12.8593V16.3242",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3195 12.8593V16.3212C17.3468 16.3279 18.1857 16.3212 18.1857 16.3212",
    stroke: "#747474",
    strokeWidth: 0.866223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/trial.36b8d79a4c7aa676ea1a719747e10efe.svg";
export { ForwardRef as ReactComponent };